import { render } from "./BuildingView.vue?vue&type=template&id=92342e8c&scoped=true"
const script = {}

import "./BuildingView.vue?vue&type=style&index=0&id=92342e8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_postcss@8.5.32_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92342e8c"]])

export default __exports__